import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { createAppStore } from '../../store';
// import { TAppState } from '../appState';

export type IReduxStore = ReturnType<typeof createAppStore>;
export type TAppState = ReturnType<IReduxStore['getState']>;
export type TDispatch = IReduxStore['dispatch'];
export type TGetState = IReduxStore['getState'];

// Use throughout your app instead of plain `useDispatch` and `useSelector`
type DispatchFunc = () => TDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export const useAppSelector: TypedUseSelectorHook<TAppState> = useSelector;
